import Vue from 'vue';
import Vuex from 'vuex';
import { getFromTemplate, getPath } from 'tools/getFromHtml';
import { isIE } from 'tools/isUserAgent';

Vue.use(Vuex);

const DE = 'de';
const LOCALE = window.stGlobals.locale;
const isGermanContent = LOCALE === DE;

const marketData = getFromTemplate('var', 'marketData') ?
    JSON.parse(getFromTemplate('var', 'marketData')) : null;
const marketDirectory = getFromTemplate('var', 'marketDirectory') ?
    JSON.parse(getFromTemplate('var', 'marketDirectory')) : null;

const marketHighlightsStore = new Vuex.Store({
    state: {
        currentOutlook: '',
        marketData,
        marketDirectory,
        basePath: getPath('outlookHubPage'),
        mapChartRankings: null,
        mapChartCategories: null,
        mapChartSelectedCategory: '',
        mapChartUnits: {},
        IS_IE: isIE(),
        isGermanContent,
    },
    mutations: {
        SET_CURRENT_OUTLOOK(state, currentOutlook) {
            state.currentOutlook = currentOutlook;
        },
        SET_MAP_RANKING_STATE(state, mapChartRankings) {
            state.mapChartRankings = mapChartRankings;
        },
        SET_MAP_CATEGORIES_STATE(state, mapChartCategories) {
            state.mapChartCategories = mapChartCategories;
        },
        SET_MAP_SELECTED_CATEGORY_STATE(state, mapChartSelectedCategory) {
            state.mapChartSelectedCategory = mapChartSelectedCategory;
        },
        SET_MAP_UNITS_STATE(state, mapChartUnits) {
            state.mapChartUnits = mapChartUnits;
        },
    },
});
export { marketHighlightsStore };
